import {
  anonIdInterceptor,
  API_BASE_PATH,
  ApiClient,
  appendAcceptWebPHeaderInterceptor,
  appendPriorityInterceptor,
  csrfTokenInterceptor,
  errorInterceptor,
  localeInterceptor,
} from '@marketplace-web/core-api/api-client-util'
// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import { tokenRefreshInterceptor } from '@marketplace-web/session-management/session-management-data'
// Temporary workaround. Resolve ASAP. Do not add more ignores like this.
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  phoneVerificationInterceptor,
  twoFAInterceptor,
} from '@marketplace-web/verification/verification-interceptors-data'

const baseURL = API_BASE_PATH

export const api = new ApiClient({ baseURL }, [
  csrfTokenInterceptor,
  errorInterceptor,
  tokenRefreshInterceptor,
  localeInterceptor,
  phoneVerificationInterceptor,
  twoFAInterceptor,
  anonIdInterceptor,
  appendAcceptWebPHeaderInterceptor,
  appendPriorityInterceptor,
])
